import { proxy, useSnapshot } from 'valtio'

// Conflict summary prefetched by the Custom Build trigger (before the Route
// Optimization modal opens), so the modal renders the constraint alert in one
// paint — same prefetch approach as the Instant Build conflict modal. `null` =
// not prefetched (modal opened without a pre-flight).
type AtomShape = {
  result: uui.domain.actions.rpc.route.ConflictVehicleSettingsResponse | null
}

export const routeOptimizationConflictsAtom = proxy<AtomShape>({ result: null })

export const setRouteOptimizationConflicts = (
  value: uui.domain.actions.rpc.route.ConflictVehicleSettingsResponse | null,
) => {
  routeOptimizationConflictsAtom.result = value
}

export function useRouteOptimizationConflicts() {
  return useSnapshot(routeOptimizationConflictsAtom).result
}
